module.exports = {
    // apiUrl: process.env.API_URL
    apiUrl: 'http://localhost:8001/api/'
};